import {getCoords, isMobile} from "./helper";
import { toggleMenu, addSticky, closeMenu } from "./navigation";
import FloatLabels from "./forms/float-labels";
import { getScreenHeight } from "./helper.js";

window.addEventListener("load", () => {
  new FloatLabels();

  toggleMenu();

  if (isMobile()) {
    closeMenu();
    addSticky();
  }
});

window.onresize = () => {
  if (isMobile()) {
    closeMenu();
    addSticky();
  }
};

window.addEventListener("scroll", function(e) {
  const headerElem = document.getElementById("headerElem");
  if (!headerElem) {
    return;
  }
  const headerOffsetTop = getCoords(headerElem).top;
  console.log(headerOffsetTop);
  if (headerOffsetTop > 0) headerElem.classList.add("scrolled");
  else headerElem.classList.remove("scrolled");
});
